module.exports = __webpack_public_path__ + "img/refresh.aa9f363c.svg";